export const BUS_LIST: { label: string; color: string }[] = [
  { label: '2224', color: 'bg-green-400' },
  { label: '2227', color: 'bg-green-400' },
  { label: '광진03', color: 'bg-green-400' },
  { label: '광진04', color: 'bg-green-400' },
  { label: '1112', color: 'bg-rose-600' },
  { label: '1117', color: 'bg-rose-600' },
  { label: '302', color: 'bg-blue-600' },
];
